/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Target_Preview_LabelInputs */



/**
* | output |
* | --- |
* | "Target Preview" |
*
* @param {Plain_Text_Import_Target_Preview_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_target_preview_label = /** @type {((inputs?: Plain_Text_Import_Target_Preview_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Target_Preview_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Apercu cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zielvorschau")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima del target")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительный просмотр цели")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa del objetivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目标预览")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ターゲットプレビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य पूर्वावलोकन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização do alvo")
	return /** @type {LocalizedString} */ ("Target Preview")
});